import { useEffect, useRef } from 'react';
import {
  type CallParticipant,
  useCallParticipants,
} from '../../useCallParticipants';
import { Deferred } from '../../../webrtc/utils/deferred';

export const useWaitForParticipantVideo = (): ((
  participant?: CallParticipant,
) => Promise<void>) => {
  const { realtimeCallParticipants } = useCallParticipants();
  const deferred = useRef(new Deferred<void>());

  useEffect(() => {
    // CS-8549: Fix the issue with participant going in PAUSE state before the video has even loaded
    const hasMediaForRealtimeParticipants = realtimeCallParticipants.some(
      (part) => {
        return (
          // if user has camera on, we wait for the video element to be present to set the state to IN_PROGRESS
          (part.state?.videoState === 'on' && part.videoElement) || // otherwise we can go straight to IN_PROGRESS but with the participant in PAUSE state
          part.state?.videoState !== 'on'
        );
      },
    );

    if (hasMediaForRealtimeParticipants) {
      deferred.current.resolve();
      deferred.current = new Deferred<void>();
    }
  }, [realtimeCallParticipants]);

  return async (_participant?: CallParticipant): Promise<void> => {
    return deferred.current.promise;
  };
};
